import React, { Component } from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { generateVehicleReport } from "../../services/reportService";

import BlockUi from "react-block-ui";
import { Table, Button, Message, Label } from "semantic-ui-react";
import TableTitle from "../common/tableTitle";
import auth from "../../services/authService";

class JVReport extends Component {
  state = {
    transactions: [],
    showSalaryForm: false,
    showError: false
  };

  async componentDidMount() {
    this.setState({ blocking: true });
    const { data: res } = await generateVehicleReport();

    this.setState({ blocking: false, transactions: res });
  }

  render() {
    if (auth.getCurrentUser().role != "client") {
      return "Your are authorized to perform this action.";
    }
    const { transactions } = this.state;
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <TableTitle title="Vehicle Report" icon="tag" />
        <center>
          <div
            className="ui error form"
            style={{
              width: "90%",
              marginTop: "20px"
            }}
          >
            <Table celled fixed singleLine>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell width={2}>Plat #</Table.HeaderCell>
                  <Table.HeaderCell width={4}>Name</Table.HeaderCell>
                  <Table.HeaderCell width={2}>Mobile Type</Table.HeaderCell>
                  <Table.HeaderCell width={6}>Company</Table.HeaderCell>
                  <Table.HeaderCell width={2}>Balance</Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                {transactions.map(transaction => (
                  <Table.Row>
                    <Table.Cell>{transaction.plat_number}</Table.Cell>
                    <Table.Cell>{transaction.name}</Table.Cell>
                    <Table.Cell>{transaction.mobile}</Table.Cell>
                    <Table.Cell>{transaction.company}</Table.Cell>
                    <Table.Cell>{transaction.balance}</Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
            <br />
          </div>
        </center>
      </BlockUi>
    );
  }
}

export default JVReport;
